import { endOfDay, endOfMonth, endOfYear, format, isValid, parseISO, startOfDay, startOfMonth, startOfYear, subDays, subYears, } from 'date-fns';
// Date inputs report yyyy-MM-dd, or "" while a segment is half-typed. Chrome
// happily accepts years like 0026 or 12026 from ordinary typing, so anything
// outside four digits from 1900 on is treated as not a real date.
export const isCompleteDate = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value))
        return false;
    const parsed = parseISO(value);
    return isValid(parsed) && parsed.getFullYear() >= 1900;
};
export const isCompleteRange = (startDate, endDate) => isCompleteDate(startDate) &&
    isCompleteDate(endDate) &&
    parseISO(startDate) <= parseISO(endDate);
// The picker shows the user's local day, so anchor the bounds to their local
// midnight-to-midnight and send the resulting instants to the API. Sending the
// bare date instead would have the server read both ends as UTC midnight,
// which drops the whole final day of the range.
export const toRangeStart = (value) => startOfDay(parseISO(value)).toISOString();
export const toRangeEnd = (value) => endOfDay(parseISO(value)).toISOString();
export const getDateRangeIssue = (startDate, endDate) => {
    if (!isCompleteDate(startDate))
        return 'start-invalid';
    if (!isCompleteDate(endDate))
        return 'end-invalid';
    if (parseISO(startDate) > parseISO(endDate))
        return 'start-after-end';
    return null;
};
export const DATE_RANGE_PRESETS = [
    'thisMonth',
    'last30Days',
    'yearToDate',
    'lastYear',
];
/**
 * How each preset reads. Beside the presets themselves so the picker offering
 * them and anything describing a stored range cannot end up calling the same
 * window two different things.
 *
 * English, and passed through `t()` at the point of use — the convention
 * everywhere else in this codebase.
 */
export const DATE_RANGE_PRESET_LABELS = {
    thisMonth: 'This month',
    last30Days: 'Last 30 days',
    yearToDate: 'Year to date',
    lastYear: 'Last year',
};
const toInputValue = (date) => format(date, 'yyyy-MM-dd');
export const getPresetRange = (preset, today) => {
    switch (preset) {
        case 'thisMonth':
            return {
                startDate: toInputValue(startOfMonth(today)),
                endDate: toInputValue(endOfMonth(today)),
            };
        case 'last30Days':
            return {
                startDate: toInputValue(subDays(today, 29)),
                endDate: toInputValue(today),
            };
        case 'yearToDate':
            return {
                startDate: toInputValue(startOfYear(today)),
                endDate: toInputValue(today),
            };
        case 'lastYear': {
            const lastYear = subYears(today, 1);
            return {
                startDate: toInputValue(startOfYear(lastYear)),
                endDate: toInputValue(endOfYear(lastYear)),
            };
        }
    }
};
